import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type SupplierModel from 'bcl/models/supplier';
import Wide from 'bcl/components/input/wide';
import Checkbox from 'bcl/components/input/checkbox';
import { on } from '@ember/modifier';

interface SupplierEditSignature {
  // The arguments accepted by the component
  Args: {
    model: SupplierModel;
    closeModal: () => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class SupplierEditComponent extends Component<SupplierEditSignature> {
  <template>
    <form class="mx-4 sm:mx-0">
      <div class="space-y-12">
        <div class="border-b border-gray-900/10 pb-12">

          <div class="grid grid-cols-1 gap-x-6 sm:grid-cols-6">

            <Wide
              @label="Name"
              @name="name"
              @type="text"
              @value={{@model.name}}
            />
            <Checkbox @label="Aktiv" @name="active" @value={{@model.active}} />
            <Wide
              @label="Lieferzeitraum"
              @name="delivery_time"
              @type="text"
              @value={{@model.delivery_time}}
            />
            <Wide
              autocomplete="off"
              @label="Kundennummer"
              @name="customer_number"
              @type="text"
              @value={{@model.customer_number}}
            />
            <Wide
              autocomplete="off"
              @label="Zusatz"
              @name="addition"
              @type="text"
              @value={{@model.additional}}
            />
            <Wide
              autocomplete="off"
              @label="Strasse"
              @name="street"
              @type="text"
              @value={{@model.street}}
            />
            <Wide
              autocomplete="off"
              @label="Hausnummer"
              @name="streetNr"
              @type="text"
              @value={{@model.street_number}}
            />
            <Wide
              autocomplete="off"
              @label="PLZ"
              @name="zip_code"
              @type="text"
              @value={{@model.zip_code}}
            />
            <Wide
              autocomplete="off"
              @label="Ort"
              @name="place"
              @type="text"
              @value={{@model.place}}
            />
            <Wide
              autocomplete="off"
              @label="Telefon"
              @name="telefon"
              @type="text"
              @value={{@model.telefon_number}}
            />
            <Wide @label="Fax" @name="fax" @type="text" @value={{@model.fax}} />
            <Wide
              autocomplete="off"
              @label="Email"
              @name="email"
              @type="text"
              @value={{@model.email}}
            />
            <Wide
              @label="PDF Kurznamen"
              @name="pdf_short_name"
              @type="text"
              @value={{@model.pdf_short_name}}
            />
          </div>
        </div>
      </div>

      <div class="mt-6 flex items-center justify-end gap-x-6">
        <button
          {{on "click" this.cancel}}
          type="button"
          class="text-sm font-semibold leading-6 text-gray-900"
        >abbrechen</button>
        <button
          {{on "click" this.save}}
          type="button"
          class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >Speichern</button>
      </div>
    </form>
  </template>
  @service declare router: RouterService;

  @action
  cancel() {
    this.args.model.rollbackAttributes();
    this.args.closeModal();
  }
  @action
  async save() {
    await this.args.model.save();
    this.args.closeModal();
  }
}
